const Security: React.FC = () => {
  return <div>Security</div>
}

export default Security
